import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CatalogComponent } from './catalog/catalog.component'
import { CompanysuppliersComponent } from './companysuppliers/companysuppliers.component';
import { EmployeesComponent } from './employees/employees.component';
import { RolesComponent } from './roles/roles.component';
import { ActivitiesComponent } from './activities/activities.component';
import { ProjectsComponent } from './projects/projects.component';
import { AreasComponent } from './areas/areas.component';
import { NdasmanagementComponent } from './ndasmanagement/ndasmanagement.component';
import { EquipmenttypesComponent } from './equipmenttypes/equipmenttypes.component';
import { IdentificationsTypes } from './identificationstypes/identificationstypes.component';
import { SitesComponent } from './sites/sites.component';
import { BuildingsComponent } from './buildings/buildings.component';
import { DocumentstypesComponent } from './documentstypes/documentstypes.component';
import { EhsExamsComponent } from './ehs-exams/ehs-exams.component';
import { SitesConfigurationsComponent } from './sites-configurations/sites-configurations.component';
import { EhsExamsResultsComponent } from './ehs-exams-results/ehs-exams-results.component';
import { PrinterConfigurationsComponent } from './printer-configurations/printer-configurations.component';
import { NewVisitComponent } from './my-requests/new-visit/new-visit.component';
import { ContactComponent } from './contact/contact.component';
import { LastReleaseComponent } from './last-release/last-release.component';
import { WithoutPermissionComponent } from './without-permission/without-permission.component';
import { MyRequestsComponent } from './my-requests/my-requests.component';
import { MyApprovalsComponent } from './my-approvals/my-approvals.component';
import { HomeComponent } from './home/home.component';
import { ReportsComponent } from './reports/reports.component';
 
const routes: Routes = [
	{ path: 'catalog', component: CatalogComponent },
	{ path: 'employees', component: EmployeesComponent },
	{ path: 'roles', component: RolesComponent },
	{ path: 'activities', component: ActivitiesComponent },
	{ path: 'projects', component: ProjectsComponent },
	{ path: 'areas', component: AreasComponent },
	{ path: 'ndamanagement', component: NdasmanagementComponent },
	{ path: 'identificationstypes', component: IdentificationsTypes },
	{ path: 'equipmenttypes', component: EquipmenttypesComponent },
	{ path: 'companysuppliers', component: CompanysuppliersComponent },
	{ path: 'catalogs/Sites', component: SitesComponent },
	{ path: 'catalogs/Buildings', component: BuildingsComponent },
	{ path: 'catalogs/DocumentsTypes', component: DocumentstypesComponent },
	{ path: 'examsmanagement', component: EhsExamsComponent },
	{ path: 'examsresults', component: EhsExamsResultsComponent },
	{ path: 'siteconfiguration', component: SitesConfigurationsComponent },
	{ path: 'printerconfigurations', component: PrinterConfigurationsComponent },
	{ path: 'new-request', component: NewVisitComponent },
	{ path: 'contact', component: ContactComponent },
	{ path: 'lastrelease', component: LastReleaseComponent },
  { path: 'without-permission', component: WithoutPermissionComponent },
  { path: 'my-requests', component: MyRequestsComponent },
  { path: 'my-approvals', component: MyApprovalsComponent },
  { path: 'home', component: HomeComponent },
  { path: 'reports', component: ReportsComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SectionsRoutingModule { }
